/**
 * PDF export preferences for Activity & Snags (sessionStorage).
 */

export const ACTIVITY_PDF_STORAGE_KEY = 'crewchain_activity_pdf_export_v1';
export const SNAGS_PDF_STORAGE_KEY = 'crewchain_snags_pdf_export_v1';

export function getDefaultActivityPdfSettings() {
  return {
    includePostDateTime: true,
    includeTeamName: true,
    includeAuthorName: true,
    includePostBody: true,
    includeMediaNotes: true,
    includeCommentThread: true,
    includeCommentAuthorNames: true,
    includeCommentImages: true,
    includeCompanyLogo: true,
  };
}

export function getDefaultSnagsPdfSettings() {
  return {
    includeIssueLabels: true,
    includeReporterName: true,
    includeReportedTime: true,
    includeAssignedTeams: true,
    includeResolvedInfo: true,
    includeResolverName: true,
    includeDescription: true,
    includeSnagPhotos: true,
    includeSnagVoiceNote: true,
    includeSiteReplies: true,
    includeSiteReplyAuthorNames: true,
    includeSiteReplyImages: true,
    includeReplyVoiceNotes: true,
    includePmNotes: true,
    includePmAuthorNames: true,
    includePmNoteImages: true,
    includePmVoiceNotes: true,
    includeCompanyLogo: true,
  };
}

function mergeActivity(raw) {
  return { ...getDefaultActivityPdfSettings(), ...raw };
}

function mergeSnags(raw) {
  return { ...getDefaultSnagsPdfSettings(), ...raw };
}

export function loadActivityPdfSettings() {
  try {
    const raw = sessionStorage.getItem(ACTIVITY_PDF_STORAGE_KEY);
    if (!raw) return getDefaultActivityPdfSettings();
    return mergeActivity(JSON.parse(raw));
  } catch {
    return getDefaultActivityPdfSettings();
  }
}

export function saveActivityPdfSettings(s) {
  try {
    sessionStorage.setItem(ACTIVITY_PDF_STORAGE_KEY, JSON.stringify(s));
  } catch {
    /* quota / private mode */
  }
}

export function loadSnagsPdfSettings() {
  try {
    const raw = sessionStorage.getItem(SNAGS_PDF_STORAGE_KEY);
    if (!raw) return getDefaultSnagsPdfSettings();
    return mergeSnags(JSON.parse(raw));
  } catch {
    return getDefaultSnagsPdfSettings();
  }
}

export function saveSnagsPdfSettings(s) {
  try {
    sessionStorage.setItem(SNAGS_PDF_STORAGE_KEY, JSON.stringify(s));
  } catch {
    /* ignore */
  }
}

/** Full detail — all content toggles on (logo follows default true). */
export function applyActivityPresetStandard() {
  return getDefaultActivityPdfSettings();
}

/** Fewer personal names; keeps teams, dates, thread text, and media. */
export function applyActivityPresetClientSafe() {
  const d = getDefaultActivityPdfSettings();
  return {
    ...d,
    includeAuthorName: false,
    includeCommentAuthorNames: false,
  };
}

export function applySnagsPresetStandard() {
  return getDefaultSnagsPdfSettings();
}

export function applySnagsPresetClientSafe() {
  const d = getDefaultSnagsPdfSettings();
  return {
    ...d,
    includeReporterName: false,
    includeSiteReplyAuthorNames: false,
    includePmAuthorNames: false,
    includeResolverName: false,
  };
}
